module.exports = __webpack_public_path__ + "71342aaf923e08a05be9a2b1f5e05d64.MP3";